export default "__VITE_ASSET__DnjJDkbP__"